// TODO: create rotateKnobs dynamically when earrings added to ear
// TODO: swap in ds-rotate for rotation knob
import EarCanvas from "earcanvas";
import * as dat from "dat.gui";
import {
  Color,
  UnsignedByteType,
  RGBEEncoding,
  LinearFilter,
  Mesh,
  SphereGeometry,
  MeshStandardMaterial,
  PMREMGenerator,
  Vector3,
  Vector2,
} from "three";
import { HDRCubeTextureLoader } from "three/examples/jsm/loaders/HDRCubeTextureLoader";
import { EXRLoader } from "three/examples/jsm/loaders/EXRLoader";

import { SAOPass } from "three/examples/jsm/postprocessing/SAOPass";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader";

import DragDrop from "ds-dragdrop";
import InputKnob from "input-knob";
import "./index.scss";

const studZones = [
  "Conch",
  "ConchContra",
  "Earlobe",
  "Helix",
  "HelixForward",
  "HelixTash",
  "Rook",
  "RookTash",
  "RookTashHidden",
  "Tragus",
  "TragusAnti",
];
const hoopZones = [
  "Conch",
  "Daith",
  "Earlobe",
  "Helix",
  "HelixForward",
  "Rook",
  "Tragus",
  "TragusAnti",
];
const drapeZones = ["RookTashHidden", "HelixTash"];

const zones = { stud: studZones, hoop: hoopZones, drape: drapeZones };
let current = null;
let earringSelector = null;
let earringType = null;
let models = null;
const earrings = [];
let earringControls = null;
let reflectionDebug = null;
let pmremGenerator = null;
// const savedEarrings = {};

// const envMap1 = null;

let earcanvas = null;
let earringButtons = null;
let itemsContainer = null;
let dragdrop = null;
let container = null;
let rotateKnob = null;

const diamondShader = {
  dispersion: 0,
  color: { r: 0, g: 0, b: 0 },
  squashFactor: 0,
  envMapIntensity: 2.688,
  refractiveIndex: 3.462,
  gammaFactor: 0,
  absorbptionFactor: 0,
  reflectivity: 0.5,
  envMapRotation: 0.0,
};
const divots = {
  divotColor: { r: 0, g: 0, b: 0 },
  opacity: 0.75,
  alphaTest: 0.009,
};
const WopalShader = {
  tintColour: { r: 200, g: 200, b: 200 },
  mainColour: { r: 0, g: 0, b: 0 },
  tintValue: 0.9,
  details: 0.9,
};
const Wopal = {
  roughness: 0.25,
  metalness: 0.25,

  tintColor: { x: 0.9, y: 0.0, z: 0.9 },
  tintIntensity: 0.4,

  noise1coef: 20,
  noise1startgradient: { x: 0.97255, y: 0.17255, z: 0.17255 },
  noise1endgradient: { x: 0.96078, y: 0.94902, z: 0.94902 },

  noise2coef: 10,
  noise2startgradient: {
    x: 0.047058823529411764,
    y: 0.9450980392156862,
    z: 0.09411764705882353,
  },
  noise2endgradient: { x: 1.0, y: 1.0, z: 1.0 },

  noise3coefs: { x: 2, y: 3, z: 1 },
  noise3startgradient: {
    x: 0.03137254901960784,
    y: 0.5647058823529412,
    z: 0.9529411764705882,
  },
  noise3endgradient: { x: 1.0, y: 1.0, z: 1.0 },
};
const LapisLazuli = {
  diffuseScale: 300,
  startBlueGradient: {
    x: 0.4196078431372549,
    y: 0.49019607843137253,
    z: 0.9529411764705882,
  },
  midBlueGradient: {
    x: 0.06666666666666667,
    y: 0.27058823529411763,
    z: 0.9333333333333333,
  },
  endBlueGradient: {
    x: 0.09411764705882353,
    y: 0.03529411764705882,
    z: 0.6078431372549019,
  },
  noiseScale: 350,
  startGoldGradient: { x: 0, y: 0, z: 0 },
  endGoldGradient: {
    x: 0.9607843137254902,
    y: 0.9098039215686274,
    z: 0.0196078431372549,
  },
  chaos: { x: 12, y: 5, z: 12 },
  clearcoatRoughness: 0.2,
  clearcoat: 0.25,
  roughness: 1,
  metalness: 1,
  envMapIntensity: 0.65,
};
const Turquoise = {
  color: { r: 0, g: 0.588, b: 0.745 },
  metalness: 0.5,
  roughness: 0.25,
  envMapIntensity: 1,
};
const BlackMoissonite = {
  color: { r: 0, g: 0, b: 0 },
  metalness: 0.5,
  roughness: 0.25,
  envMapIntensity: 0.75,
};
const pearl = {
  clearcoatRoughness: 0.2,
  clearcoat: 0.25,
  roughness: 1,
  metalness: 1,
  envMapIntensity: 0.85,
  blueNoiseCoef: 10,
  blueNoiseStart: {
    x: 0.9803921568627451,
    y: 0.9450980392156862,
    z: 0.9450980392156862,
  },
  blueNoiseMid: {
    x: 0.9725490196078431,
    y: 0.9529411764705882,
    z: 0.9176470588235294,
  },
  blueNoiseEnd: { x: 1, y: 1, z: 1 },

  goldNoiseCoef: 300,
  goldNoiseStart: { x: 1, y: 1, z: 1 },
  goldNoiseMid: {
    x: 0.9725490196078431,
    y: 0.8666666666666667,
    z: 0.5294117647058824,
  },
  goldNoiseEnd: {
    x: 0.8862745098039215,
    y: 0.9607843137254902,
    z: 0.0196078431372549,
  },

  colorFlecksCoef: 30,
  colorFlecksStart: { x: 1, y: 0.9725490196078431, z: 0.9725490196078431 },
  colorFlecksMid: {
    x: 0.49411764705882355,
    y: 0.7098039215686275,
    z: 0.9803921568627451,
  },
  colorFlecksEnd: {
    x: 0.9725490196078431,
    y: 0.9568627450980393,
    z: 0.9725490196078431,
  },
};

const tigerEye = {
  clearcoatRoughness: 0.5,
  clearcoat: 0.75,
  roughness: 0.4,
  metalness: 0.5,
  envMapIntensity: 0.28,
  noise1coefs: { x: 11.6, y: 0.0, z: 33.4 },
  noise1startgradient: { x: 0.0, y: 0.0, z: 0.0 },
  noise1endgradient: { x: 0.98, y: 0.72, z: 0.0 },

  noise2coefs: { x: 14, y: 0, z: 0 },
  noise2startgradient: { x: 1, y: 0.72, z: 0 },
  noise2endgradient: { x: 0.0, y: 0.0, z: 0.0 },

  noise3coefs: { x: 12.8, y: 0.0, z: 49.5 },
  noise3startgradient: { x: 0, y: 0, z: 0 },
  noise3endgradient: { x: 0.73, y: 0.46, z: 0.0 },

  noise4coefs: { x: 30, y: 30, z: 58 },
  noise4startgradient: { x: 0.0, y: 0.0, z: 0.0 },
  noise4endgradient: { x: 0.72, y: 0.58, z: 0 },
};

const settings = {
  skinShader: { opacity: 0.25 },
  light: {
    intensity: 1,
    position: {
      x: -1,
      y: -1.5,
      z: 0,
    },
  },
  environment: {
    image: "studio",
    z: -2.953,
    y: 3.142,
  },
  IBL: {
    z: 0.0,
    y: 0.0,
    rotation: -180,
  },
  diamondShader: {
    dispersion: 0.1,
  },
  metalShaders: {
    yellowgold14: {
      metalness: 0.707,
      roughness: 0.301,
      envMapIntensity: 2.47,
      color: { r: 255, g: 130, b: 43 },
    },
    whitegold14: {
      metalness: 0.875,
      roughness: 0.1,
      envMapIntensity: 1.4,
      color: { r: 214, g: 214, b: 214 },
    },
    rosegold14: {
      metalness: 0.414,
      roughness: 0.09,
      envMapIntensity: 3,
      color: { r: 240, g: 109, b: 65 },
    },
    blackgold14: {
      metalness: 1,
      roughness: 0.01,
      envMapIntensity: 2,
      color: { r: 11, g: 9, b: 8 },
    },
    yellowgold18: {
      metalness: 0.73,
      roughness: 0,
      envMapIntensity: 1.607,
      color: { r: 255, g: 130, b: 43 },
    },
    whitegold18: {
      metalness: 0.9,
      roughness: 0.168,
      envMapIntensity: 1.8,
      color: { r: 211, g: 211, b: 209 },
    },
    rosegold18: {
      metalness: 1,
      roughness: 0.01,
      envMapIntensity: 1.5,
      color: { r: 250, g: 105, b: 70 },
    },
    blackgold18: {
      metalness: 1,
      roughness: 0.01,
      envMapIntensity: 1.2,
      color: { r: 11, g: 9, b: 8 },
    },
  },
};
const startSettings = JSON.parse(JSON.stringify(settings));

window.settings = settings;
// const savedSettings = JSON.parse(localStorage.getItem('settings')) || {};
// Object.assign(settings, savedSettings);

const saveBanner = document.querySelector("#savebanner");

let updated = null;

const gui = new dat.GUI({
  // load: cachedSettings,
});
window.gui = gui;
const envSettings = gui.addFolder("Environment");
const skinSettings = gui.addFolder("Skin Shader");
const DivotsSettings = gui.addFolder("Divots");
const diamondSettings = gui.addFolder("Diamond Shader");
const WopalSettings = gui.addFolder("White Opal Shader");
const LLSettings = gui.addFolder("Lapis Lazuli Shader");
const TQsettings = gui.addFolder("Turqoise Shader");
const TESettings = gui.addFolder("Tiger's Eye Shader");
const PESettings = gui.addFolder("Pearl Shader");
const BMSettings = gui.addFolder("Black Moissanite Shader");
const metalSettings = gui.addFolder("Metal Shaders");
const postprocessingSettings = gui.addFolder("Post Processing");

const bloomFolder = postprocessingSettings.addFolder("Bloom");
const saoFolder = postprocessingSettings.addFolder("Ambient Occlusion");

gui.close();
// const zones = null;

const saveSettings = {
  save() {
    // localStorage.setItem('settings', JSON.stringify(settings));
    saveBanner.classList.remove("hidden");
    setTimeout(() => {
      saveBanner.classList.add("hidden");
    }, 2000);
  },
};

const clearSettings = {
  clear() {
    // localStorage.setItem('settings', '{}');
    // location.reload();
    Object.assign(settings, startSettings);
  },
};
gui.add(saveSettings, "save");
gui.add(clearSettings, "clear");

let errorMessage = null;

const showError = (message) => {
  errorMessage.innerText = message;
  errorMessage.classList.remove("hidden");
  setTimeout(() => {
    errorMessage.classList.add("hidden");
  }, 2000);
};

const origin =
  window.location.hostname === "localhost"
    ? "http://localhost:8003"
    : "https://earcanvas.inginius.fr";
console.log(origin);
const createItemButton = (id) => {
  const button = document.createElement("button");
  button.setAttribute("data-id", id);
  button.innerText = id;
  button.addEventListener("click", ({ target }) => {
    console.log(target.getAttribute("data-id"));
    earcanvas.zoomInto(target.getAttribute("data-id"));
  });
  return button;
};

const getModels = () => {
  fetch(`${origin}/mt-earcanvas/models`)
    .then(
      (res) => res.json(),
      (reason) => {
        console.log("Could not load models", reason);
      }
    )
    .then((res) => {
      models = res.map((file) => `${origin}/mt-earcanvas/model/${file}`);
      earringSelector.innerHTML = "";
      res.forEach((item) => {
        const itemEl = document.createElement("option");
        itemEl.innerText = item;
        itemEl.value = `${origin}/mt-earcanvas/model/${item}`;
        earringSelector.appendChild(itemEl);
      });
      earringButtons.innerHTML = "";
      let updatedFile = null;
      res.forEach((file) => {
        const button = document.createElement("div");

        const modelButton = document.createElement("button");
        modelButton.className = "model";
        button.setAttribute(
          "data-file",
          `${origin}/mt-earcanvas/model/${file}`
        );
        modelButton.innerText = file;
        if (updated && updated === file) {
          updatedFile = button;
          modelButton.classList.add("updated");
          setTimeout(() => {
            modelButton.classList.remove("updated");
            updated = null;
          }, 2000);
        }

        const typeButton = document.createElement("button");
        typeButton.setAttribute("draggable", false);
        typeButton.innerText = "stud";
        typeButton.className = "type";
        typeButton.typeIndex = 0;

        const types = ["stud", "hoop", "charm", "drape"];
        typeButton.addEventListener("click", () => {
          typeButton.typeIndex += 1;
          typeButton.typeIndex %= types.length;
          typeButton.innerText = types[typeButton.typeIndex];
        });
        const deleteButton = document.createElement("button");
        deleteButton.setAttribute("draggable", false);
        deleteButton.className = "delete";
        deleteButton.addEventListener("click", () => {
          console.log("deleting", file);
          fetch(`${origin}/mt-earcanvas/deleteModel/${file}`)
            .then((res) => res.json())
            .then(({ success }) => {
              if (success) getModels();
            });
        });

        const addButton = document.createElement("button");
        addButton.setAttribute("draggable", false);
        addButton.className = "default";
        addButton.innerText = "add";
        addButton.addEventListener("click", ({ target }) => {
          const id = `earring_${earrings.length}`;
          const model = target.parentNode.getAttribute("data-file");
          const type = target.parentNode.querySelector(".type").innerText;
          const zonesForType = zones[type];
          const randomZone =
            zonesForType[Math.floor(Math.random() * zonesForType.length)];
          earcanvas
            .addItem(id, {
              id,
              model,
              type,
              zone: randomZone,
              zones: zones[type],
            })
            .then((res) => {
              if (res.error) return showError(res.error);
              // let collider = null;
              // earcanvas.state.items[res.id].mesh.traverse((obj) => { if (obj.name.toLowerCase().indexOf('collider') >= 0) collider = obj; });
              // if (!collider || !collider.isMesh) showError('no collider found in mesh');
              if (!res.error) {
                earrings.push(res.id);
                const itemButton = createItemButton(res.id);
                itemsContainer.appendChild(itemButton);
              }
            });
        });

        button.appendChild(modelButton);
        button.appendChild(typeButton);
        button.appendChild(addButton);
        button.appendChild(deleteButton);
        earringButtons.appendChild(button);
      });

      if (updatedFile) updatedFile.scrollIntoView({ behavior: "smooth" });

      dragdrop = new DragDrop(earringButtons, container, {
        size: { width: 50, height: 50 },
      });
      window.dragdrop = dragdrop;

      dragdrop.element.addEventListener("dragged", ({ detail }) => {
        const file = detail.getAttribute("data-file");
        const type = detail.querySelector(".type").innerText;
        earcanvas.prepareItem(file, type, zones[type]); // TODO: eventually this will be an object with types: { stud, hoop, chain, charm }
      });

      dragdrop.element.addEventListener("dropped", ({ detail }) => {
        if (!detail.inDropZone) {
          earcanvas.cancelPrepareItem();
        } else {
          const type = detail.element.querySelector(".type").innerText;
          let itemZones = zones[type];

          earcanvas
            .addItem("sku", {
              id: `earring_${earrings.length}`,
              type,
              model: detail.element.getAttribute("data-file"),
              zones: itemZones,
            })
            .then((res) => {
              if (res.error) {
                earcanvas.cancelPrepareItem();
                return showError(res.error);
              }
              let collider = null;
              earcanvas.state.items[res.id].mesh.traverse((obj) => {
                if (obj.name.toLowerCase().indexOf("collider") >= 0)
                  collider = obj;
              });
              if (!collider || !collider.isMesh)
                showError("no collider found in mesh");
              if (!res.error) {
                earrings.push(res.id);
                const itemButton = createItemButton(res.id);
                itemsContainer.appendChild(itemButton);
              }
            });
        }
      });
    });
};

const studioImages = [
  "assets/studio_0.hdr",
  "assets/studio_1.hdr",
  "assets/studio_2.hdr",
  "assets/studio_3.hdr",
  "assets/studio_4.hdr",
  "assets/studio_5.hdr",
];

const xmasStudioImages = [
  "assets/xmas-studio_0.hdr",
  "assets/xmas-studio_1.hdr",
  "assets/xmas-studio_2.hdr",
  "assets/xmas-studio_3.hdr",
  "assets/xmas-studio_4.hdr",
  "assets/xmas-studio_5.hdr",
];

const colorfulStudioImages = [
  "assets/colorful-studio_0.hdr",
  "assets/colorful-studio_1.hdr",
  "assets/colorful-studio_2.hdr",
  "assets/colorful-studio_3.hdr",
  "assets/colorful-studio_4.hdr",
  "assets/colorful-studio_5.hdr",
];

const londonHallImages = [
  "assets/london-hall_0.hdr",
  "assets/london-hall_1.hdr",
  "assets/london-hall_2.hdr",
  "assets/london-hall_3.hdr",
  "assets/london-hall_4.hdr",
  "assets/london-hall_5.hdr",
];

const broadWayHallImages = [
  "assets/broadway-hall_0.hdr",
  "assets/broadway-hall_1.hdr",
  "assets/broadway-hall_2.hdr",
  "assets/broadway-hall_3.hdr",
  "assets/broadway-hall_4.hdr",
  "assets/broadway-hall_5.hdr",
];

const envs = {
  // studio: { images: studioImages },
  // xmasStudio: { images: xmasStudioImages },
  // colorfulStudio: { images: colorfulStudioImages },
  // londonHall: { images: londonHallImages },
  // broadwayHall: { images: broadWayHallImages },
  prostudio: { image: "assets/prostudio.exr" },
  iphone: { image: "assets/iphone.exr" },
  tent: { image: "assets/tent.exr" },
  "surrounded-tent": { image: "assets/surrounded-tent.exr" },
  "19sm": { image: "assets/19sm.exr" },
  "19sm-soft": { image: "assets/19sm-soft.exr" },
};

// Object.keys(envs).forEach((env) => {
//   new HDRCubeTextureLoader()
//     .setDataType(UnsignedByteType)
//     .load(envs[env].images, (hdrCubeMap) => {
//       hdrCubeMap.encoding = RGBEEncoding;
//       envs[env].map = hdrCubeMap;
//       envs[env].map.minFilter = LinearFilter;
//     });
// });

Object.keys(envs).forEach((env) => {
  new EXRLoader().load(envs[env].image, (texture) => {
    // texture.encoding = RGBEEncoding;
    envs[env].map = pmremGenerator.fromEquirectangular(texture).texture;
    // envs[env].map.minFilter = LinearFilter;
  });
});

window.envs = envs;

const setupControls = () => {
  // const skinMaterial = earcanvas.canvas.ears.left.material;
  // const { r, g, b } = skinMaterial.color;
  // const skin = { color: { r: Math.floor(r * 256), g: Math.floor(g * 256), b: Math.floor(b * 256) }, normal: 1 };
  // skinSettings.add(skinMaterial, 'roughness', 0, 1, 0.001);
  // if (savedSettings && savedSettings.skinShader && savedSettings.skinShader.opacity !== undefined) earcanvas.canvas.shadowMaterial.opacity = savedSettings.skinShader.opacity;
  // earcanvas.canvas.shadowMaterial.opacity = settings.skinShader.opacity;
  // skinSettings.add(earcanvas.canvas.shadowMaterial, 'opacity', 0, 1, 0.001).onChange((value) => {
  //   settings.skinShader.opacity = value;
  //   if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  // });
  // skinSettings.add(skin, 'normal', 0, 2, 0.001).onChange((value) => {
  //   skinMaterial.normalScale.x = value;
  //   skinMaterial.normalScale.y = value;
  // });
  // skinSettings.addColor(skin, 'color').onChange(({ r, g, b }) => {
  //   skinMaterial.color = new Color(`rgb(${Math.floor(r)}, ${Math.floor(g)}, ${Math.floor(b)})`);
  // });

  // earcanvas.scene.overrideMaterial = new MeshStandardMaterial({ color: 0xeeeeee });

  // if (savedSettings && savedSettings.diamondShader && savedSettings.diamondShader.dispersion !== undefined) {
  //   diamondShader.dispersion = savedSettings.diamondShader.dispersion;
  //   earcanvas.canvas.diamondMaterials.forEach((mat) => {
  //     mat.dispersion = diamondShader.dispersion;
  //   });
  //   if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  // }

  TQsettings.add(Turquoise, "roughness", 0, 1, 0.01).onChange((value) => {
    Turquoise.roughness = value;
    earcanvas.canvas.customShaders["TQ"].roughness = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  TQsettings.add(Turquoise, "metalness", 0, 1, 0.01).onChange((value) => {
    Turquoise.metalness = value;
    earcanvas.canvas.customShaders["TQ"].metalness = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  TQsettings.add(Turquoise, "envMapIntensity", 0, 1, 0.01).onChange((value) => {
    Turquoise.envMapIntensity = value;
    earcanvas.canvas.customShaders["TQ"].envMapIntensity = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  //TQsettings.addColor();
  addColorFloat(TQsettings, Turquoise.color, "TQ", "color", true);
  addColorFloat(BMSettings, BlackMoissonite.color, "BM", "color", true);

  BMSettings.add(BlackMoissonite, "roughness", 0, 1, 0.01).onChange((value) => {
    BlackMoissonite.roughness = value;
    earcanvas.canvas.customShaders["BM"].roughness = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  BMSettings.add(BlackMoissonite, "metalness", 0, 1, 0.01).onChange((value) => {
    BlackMoissonite.metalness = value;
    earcanvas.canvas.customShaders["BM"].metalness = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  BMSettings.add(BlackMoissonite, "envMapIntensity", 0, 1, 0.01).onChange(
    (value) => {
      BlackMoissonite.envMapIntensity = value;
      earcanvas.canvas.customShaders["BM"].metalness = value;
      if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
    }
  );

  LLUI();
  PEUI();
  TEUI();
  wopalUI();

  /* WopalSettings.add(WopalShader.mainColour, 'r', 0, 255, 1).onChange((value)=>{
    const uniformValue = earcanvas.canvas.customShaders["Wopal"].uniforms["color"].value;
    earcanvas.canvas.customShaders["Wopal"].uniforms["color"].value = new Vector3(Math.floor(value), 
                                        Math.floor(uniformValue.y ), 
                                        Math.floor(uniformValue.z));
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  WopalSettings.add(WopalShader.mainColour, 'g', 0, 255, 1).onChange((value)=>{
    const uniformValue = earcanvas.canvas.customShaders["Wopal"].uniforms["color"].value;
    earcanvas.canvas.customShaders["Wopal"].uniforms["color"].value = new Vector3(Math.floor(uniformValue.x), 
                                        Math.floor(value), 
                                        Math.floor(uniformValue.z));
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  WopalSettings.add(WopalShader.mainColour, 'b', 0, 255, 1).onChange((value)=>{
    const uniformValue = earcanvas.canvas.customShaders["Wopal"].uniforms["color"].value;
    earcanvas.canvas.customShaders["Wopal"].uniforms["color"].value = new Vector3(Math.floor(uniformValue.x), 
                                       Math.floor(uniformValue.y), 
                                        Math.floor(value));
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });

  WopalSettings.add(WopalShader.tintColour, 'r', 0, 255, 1).onChange((value)=>{
    const uniformValue = earcanvas.canvas.customShaders["Wopal"].uniforms["tint"].value;
    earcanvas.canvas.customShaders["Wopal"].uniforms["tint"].value = new Vector3(Math.floor(value), 
                                        Math.floor(uniformValue.y ), 
                                        Math.floor(uniformValue.z));
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  WopalSettings.add(WopalShader.tintColour, 'g', 0, 255, 1).onChange((value)=>{
    const uniformValue = earcanvas.canvas.customShaders["Wopal"].uniforms["tint"].value;
    earcanvas.canvas.customShaders["Wopal"].uniforms["tint"].value = new Vector3(Math.floor(uniformValue.x), 
                                        Math.floor(value), 
                                        Math.floor(uniformValue.z));
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  WopalSettings.add(WopalShader.tintColour, 'b', 0, 255, 1).onChange((value)=>{
    const uniformValue = earcanvas.canvas.customShaders["Wopal"].uniforms["tint"].value;
    earcanvas.canvas.customShaders["Wopal"].uniforms["tint"].value = new Vector3(Math.floor(uniformValue.x), 
                                       Math.floor(uniformValue.y), 
                                        Math.floor(value));
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });

  WopalSettings.add(WopalShader, 'tintValue', 0, 10, 0.01).onChange((value) => {
    const uniformtint = earcanvas.canvas.customShaders["Wopal"].uniforms["tintVal"];
    uniformtint.value = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });

  WopalSettings.add(WopalShader, 'details', 0, 10, 0.01).onChange((value) => {
    const uniformtint = earcanvas.canvas.customShaders["Wopal"].uniforms["details"];
    uniformtint.value = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  }); */

  DivotsSettings.add(divots, "opacity", 0, 1, 0.01).onChange((value) => {
    const mat = earcanvas.canvas.holeMaterial;
    mat.opacity = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });

  DivotsSettings.add(divots.divotColor, "r", 0, 255, 1).onChange((value) => {
    earcanvas.canvas.holeMaterial.color = new Color(`rgb(${Math.floor(value)}, 
                                        ${Math.floor(
                                          earcanvas.canvas.holeMaterial.color
                                            .g * 255
                                        )}, 
                                        ${Math.floor(
                                          earcanvas.canvas.holeMaterial.color
                                            .b * 255
                                        )})`);
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  DivotsSettings.add(divots.divotColor, "g", 0, 255, 1).onChange((value) => {
    earcanvas.canvas.holeMaterial.color = new Color(`rgb(${Math.floor(
      earcanvas.canvas.holeMaterial.color.r * 255
    )}, 
                                        ${Math.floor(value)}, 
                                        ${Math.floor(
                                          earcanvas.canvas.holeMaterial.color
                                            .b * 255
                                        )})`);
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  DivotsSettings.add(divots.divotColor, "b", 0, 255, 1).onChange((value) => {
    earcanvas.canvas.holeMaterial.color = new Color(`rgb(${Math.floor(
      earcanvas.canvas.holeMaterial.color.r * 255
    )}, 
                                        ${Math.floor(
                                          earcanvas.canvas.holeMaterial.color
                                            .g * 255
                                        )}, 
                                        ${Math.floor(value)})`);
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  diamondSettings
    .add(diamondShader, "dispersion", -1, 1, 0.001)
    .onChange((value) => {
      // console.log(e, earcanvas.diamondMaterials);
      settings.diamondShader.dispersion = value;

      if (earcanvas.canvas.state.activeItem) {
        earcanvas.canvas.diamondMaterials[
          earcanvas.canvas.state.activeItem
        ].forEach((mat) => {
          mat.dispersion = value;
        });
      } else {
        Object.keys(earcanvas.canvas.diamondMaterials).forEach((key) => {
          const diamonds = earcanvas.canvas.diamondMaterials[key];
          diamonds.forEach((mat) => {
            mat.dispersion = value;
          });
        });
      }
      if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
    });

  diamondSettings
    .add(diamondShader, "envMapIntensity", 0, 10, 0.001)
    .onChange((value) => {
      if (earcanvas.canvas.state.activeItem) {
        earcanvas.canvas.diamondMaterials[
          earcanvas.canvas.state.activeItem
        ].forEach((mat) => {
          mat.uniforms.envMapIntensity.value = value;
        });
      } else {
        Object.keys(earcanvas.canvas.diamondMaterials).forEach((key) => {
          const diamonds = earcanvas.canvas.diamondMaterials[key];
          diamonds.forEach((mat) => {
            mat.uniforms.envMapIntensity.value = value;
          });
        });
      }
      if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
    });

  diamondSettings
    .add(diamondShader, "refractiveIndex", 1, 5, 0.001)
    .onChange((value) => {
      if (earcanvas.canvas.state.activeItem) {
        earcanvas.canvas.diamondMaterials[
          earcanvas.canvas.state.activeItem
        ].forEach((mat) => {
          mat.refractiveIndex = value;
        });
      } else {
        Object.keys(earcanvas.canvas.diamondMaterials).forEach((key) => {
          const diamonds = earcanvas.canvas.diamondMaterials[key];
          diamonds.forEach((mat) => {
            mat.refractiveIndex = value;
          });
        });
      }
      if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
    });

  diamondSettings
    .add(diamondShader, "squashFactor", 0.1, 1, 0.001)
    .onChange((value) => {
      if (earcanvas.canvas.state.activeItem) {
        earcanvas.canvas.diamondMaterials[
          earcanvas.canvas.state.activeItem
        ].forEach((mat) => {
          mat.squashFactor = value;
        });
      } else {
        Object.keys(earcanvas.canvas.diamondMaterials).forEach((key) => {
          const diamonds = earcanvas.canvas.diamondMaterials[key];
          diamonds.forEach((mat) => {
            mat.squashFactor = value;
          });
        });
      }
      if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
    });

  diamondSettings.add(diamondShader, "gammaFactor", 1, 2).onChange((value) => {
    if (earcanvas.canvas.state.activeItem) {
      earcanvas.canvas.diamondMaterials[
        earcanvas.canvas.state.activeItem
      ].forEach((mat) => {
        mat.gammaFactor = value;
      });
    } else {
      Object.keys(earcanvas.canvas.diamondMaterials).forEach((key) => {
        const diamonds = earcanvas.canvas.diamondMaterials[key];
        diamonds.forEach((mat) => {
          mat.gammaFactor = value;
        });
      });
    }

    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });

  diamondSettings
    .add(diamondShader, "absorbptionFactor", 1, 5, 0.01)
    .onChange((value) => {
      if (earcanvas.canvas.state.activeItem) {
        earcanvas.canvas.diamondMaterials[
          earcanvas.canvas.state.activeItem
        ].forEach((mat) => {
          mat.absorbptionFactor = value;
        });
      } else {
        Object.keys(earcanvas.canvas.diamondMaterials).forEach((key) => {
          const diamonds = earcanvas.canvas.diamondMaterials[key];
          diamonds.forEach((mat) => {
            mat.absorbptionFactor = value;
          });
        });
      }
      if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
    });

  diamondSettings
    .add(diamondShader, "reflectivity", 0.0, 1.0, 0.01)
    .onChange((value) => {
      if (earcanvas.canvas.state.activeItem) {
        earcanvas.canvas.diamondMaterials[
          earcanvas.canvas.state.activeItem
        ].forEach((mat) => {
          mat.uniforms.reflectivity.value = value;
        });
      } else {
        Object.keys(earcanvas.canvas.diamondMaterials).forEach((key) => {
          const diamonds = earcanvas.canvas.diamondMaterials[key];
          diamonds.forEach((mat) => {
            mat.uniforms.reflectivity.value = value;
          });
        });
      }
      if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
    });

  diamondSettings
    .add(diamondShader, "envMapRotation", 0.0, 6.28, 0.01)
    .onChange((value) => {
      if (earcanvas.canvas.state.activeItem) {
        earcanvas.canvas.diamondMaterials[
          earcanvas.canvas.state.activeItem
        ].forEach((mat) => {
          mat.uniforms.envMapRotation.value = value;
        });
      } else {
        Object.keys(earcanvas.canvas.diamondMaterials).forEach((key) => {
          const diamonds = earcanvas.canvas.diamondMaterials[key];
          diamonds.forEach((mat) => {
            mat.uniforms.envMapRotation.value = value;
          });
        });
      }
      if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
    });

  diamondSettings.add(diamondShader.color, "r", 0, 255, 1).onChange((value) => {
    if (earcanvas.canvas.state.activeItem) {
      earcanvas.canvas.diamondMaterials[
        earcanvas.canvas.state.activeItem
      ].forEach((mat) => {
        mat.color = new Color(
          `rgb(${Math.floor(value)}, ${Math.floor(
            mat.color.g * 255
          )}, ${Math.floor(mat.color.b * 255)})`
        );
      });
    } else {
      Object.keys(earcanvas.canvas.diamondMaterials).forEach((key) => {
        const diamonds = earcanvas.canvas.diamondMaterials[key];
        diamonds.forEach((mat) => {
          mat.color = new Color(
            `rgb(${Math.floor(value)}, ${Math.floor(
              mat.color.g * 255
            )}, ${Math.floor(mat.color.b * 255)})`
          );
        });
      });
    }
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  diamondSettings.add(diamondShader.color, "g", 0, 255, 1).onChange((value) => {
    if (earcanvas.canvas.state.activeItem) {
      earcanvas.canvas.diamondMaterials[
        earcanvas.canvas.state.activeItem
      ].forEach((mat) => {
        mat.color = new Color(
          `rgb(${Math.floor(mat.color.r * 255)}, ${Math.floor(
            value
          )}, ${Math.floor(mat.color.b * 255)})`
        );
      });
    } else {
      Object.keys(earcanvas.canvas.diamondMaterials).forEach((key) => {
        const diamonds = earcanvas.canvas.diamondMaterials[key];
        diamonds.forEach((mat) => {
          mat.color = new Color(
            `rgb(${Math.floor(mat.color.r * 255)}, ${Math.floor(
              value
            )}, ${Math.floor(mat.color.b * 255)})`
          );
        });
      });
    }

    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  diamondSettings.add(diamondShader.color, "b", 0, 255, 1).onChange((value) => {
    if (earcanvas.canvas.state.activeItem) {
      earcanvas.canvas.diamondMaterials[
        earcanvas.canvas.state.activeItem
      ].forEach((mat) => {
        mat.color = new Color(
          `rgb(${Math.floor(mat.color.r * 255)}, ${Math.floor(
            mat.color.g * 255
          )}, ${Math.floor(value)})`
        );
      });
    } else {
      Object.keys(earcanvas.canvas.diamondMaterials).forEach((key) => {
        const diamonds = earcanvas.canvas.diamondMaterials[key];
        diamonds.forEach((mat) => {
          mat.color = new Color(
            `rgb(${Math.floor(mat.color.r * 255)}, ${Math.floor(
              mat.color.g * 255
            )}, ${Math.floor(value)})`
          );
        });
      });
    }
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });

  diamondSettings.addColor(diamondShader, "color").onChange(({ r, g, b }) => {
    if (earcanvas.canvas.state.activeItem) {
      earcanvas.canvas.diamondMaterials[
        earcanvas.canvas.state.activeItem
      ].forEach((mat) => {
        mat.color = new Color(
          `rgb(${Math.floor(r)}, ${Math.floor(g)}, ${Math.floor(b)})`
        );
      });
    } else {
      Object.keys(earcanvas.canvas.diamondMaterials).forEach((key) => {
        const diamonds = earcanvas.canvas.diamondMaterials[key];
        diamonds.forEach((mat) => {
          mat.color = new Color(
            `rgb(${Math.floor(r)}, ${Math.floor(g)}, ${Math.floor(b)})`
          );
        });
      });
    }
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });

  const metalSettingsObject = {};
  const metals = {
    yellowgold14: { color: { r: 0, g: 0, b: 0 } },
    whitegold14: { color: { r: 0, g: 0, b: 0 } },
    rosegold14: { color: { r: 0, g: 0, b: 0 } },
    blackgold14: { color: { r: 0, g: 0, b: 0 } },
    yellowgold18: { color: { r: 0, g: 0, b: 0 } },
    whitegold18: { color: { r: 0, g: 0, b: 0 } },
    rosegold18: { color: { r: 0, g: 0, b: 0 } },
    blackgold18: { color: { r: 0, g: 0, b: 0 } },
  };
  Object.keys(metals).forEach((metal) => {
    metalSettingsObject[metal] = metalSettings.addFolder(`${metal} settings`);
    metals[metal].color.r = earcanvas.canvas.metals[metal].color.r * 255;
    metals[metal].color.g = earcanvas.canvas.metals[metal].color.g * 255;
    metals[metal].color.b = earcanvas.canvas.metals[metal].color.b * 255;
    // console.log(settings.metalShaders[metal]);
    earcanvas.canvas.metals[metal].metalness =
      settings.metalShaders[metal].metalness;
    metalSettingsObject[metal]
      .add(earcanvas.canvas.metals[metal], "metalness", 0, 1, 0.001)
      .onChange((value) => {
        settings.metalShaders[metal].metalness = value;
        if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
      });
    earcanvas.canvas.metals[metal].roughness =
      settings.metalShaders[metal].roughness;
    metalSettingsObject[metal]
      .add(earcanvas.canvas.metals[metal], "roughness", 0, 1, 0.001)
      .onChange((value) => {
        settings.metalShaders[metal].roughness = value;
        if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
      });
    earcanvas.canvas.metals[metal].envMapIntensity =
      settings.metalShaders[metal].envMapIntensity;
    metalSettingsObject[metal]
      .add(earcanvas.canvas.metals[metal], "envMapIntensity", 0, 10, 0.001)
      .onChange((value) => {
        settings.metalShaders[metal].envMapIntensity = value;
        if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
      });

    earcanvas.canvas.metals[metal].color.r =
      settings.metalShaders[metal].color.r / 255;
    earcanvas.canvas.metals[metal].color.g =
      settings.metalShaders[metal].color.g / 255;
    earcanvas.canvas.metals[metal].color.b =
      settings.metalShaders[metal].color.b / 255;

    metalSettingsObject[metal]
      .add(earcanvas.canvas.metals[metal].color, "r", 0, 255, 1)
      .onChange((value) => {
        settings.metalShaders[metal].color.r = value;
        const { color } = earcanvas.canvas.metals[metal];
        earcanvas.canvas.metals[metal].color = new Color(
          `rgb(${Math.floor(value)}, ${Math.floor(color.g * 255)}, ${Math.floor(
            color.b * 255
          )})`
        );
        if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
      });
    metalSettingsObject[metal]
      .add(earcanvas.canvas.metals[metal].color, "g", 0, 255, 1)
      .onChange((value) => {
        settings.metalShaders[metal].color.g = value;
        const { color } = earcanvas.canvas.metals[metal];
        earcanvas.canvas.metals[metal].color = new Color(
          `rgb(${Math.floor(color.r * 255)}, ${Math.floor(value)}, ${Math.floor(
            color.b * 255
          )})`
        );
        if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
      });
    metalSettingsObject[metal]
      .add(earcanvas.canvas.metals[metal].color, "b", 0, 255, 1)
      .onChange((value) => {
        settings.metalShaders[metal].color.b = value;
        const { color } = earcanvas.canvas.metals[metal];
        earcanvas.canvas.metals[metal].color = new Color(
          `rgb(${Math.floor(color.r * 255)}, ${Math.floor(
            color.g * 255
          )}, ${Math.floor(value)})`
        );
        if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
      });

    // removed: metal color picker
    // metalSettingsObject[metal].addColor(metals[metal], 'color').onChange(({ r, g, b }) => {
    //   settings.metalShaders[metal].color.r = r / 255;
    //   settings.metalShaders[metal].color.g = g / 255;
    //   settings.metalShaders[metal].color.b = b / 255;

    //   earcanvas.canvas.metals[metal].color = new Color(`rgb(${Math.floor(r)}, ${Math.floor(g)}, ${Math.floor(b)})`);
    //   if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
    // });
    // metalSettingsObject[metal].open();
  });

  // earcanvas.canvas.lights[0].intensity = settings.light.intensity;
  // earcanvas.canvas.lights[0].position.x = settings.light.position.x;
  // earcanvas.canvas.lights[0].position.y = settings.light.position.y;
  // earcanvas.canvas.lights[0].position.z = settings.light.position.z;

  earcanvas.canvas.lights.forEach((light) => {
    envSettings[light.name] = envSettings.addFolder(`${light.name} settings`);
    envSettings[light.name]
      .add(light, "intensity", 0, 10, 0.001)
      .onChange((value) => {
        settings.light.intensity = value;
        earcanvas.canvas.render(true);
      });
    envSettings[light.name]
      .add(light.position, "x", -3, 3, 0.001)
      .onChange((value) => {
        settings.light.position.x = value;
        earcanvas.canvas.render(true);
      });
    envSettings[light.name]
      .add(light.position, "y", -3, 3, 0.001)
      .onChange((value) => {
        settings.light.position.y = value;
        earcanvas.canvas.render(true);
      });
    envSettings[light.name]
      .add(light.position, "z", -3, 3, 0.001)
      .onChange((value) => {
        settings.light.position.z = value;
        earcanvas.canvas.render(true);
      });
    envSettings[light.name]
      .add({ castShadow: false }, "castShadow")
      .onChange((val) => {
        light.castShadow = val;
      });

    envSettings[light.name].add(light.shadow.camera, "near", 0, 10, 0.001); // default
    envSettings[light.name].add(light.shadow.camera, "far", 0, 10, 0.001); // default
    envSettings[light.name].add(
      light.shadow,
      "bias",
      -0.001,
      -0.000001,
      0.00001
    );
    envSettings[light.name].add(light.shadow, "radius", 0, 24, 0.001);
  });

  // if (savedSettings && savedSettings.environment && savedSettings.environment.image !== undefined) {
  //   earcanvas.canvas.background = envs[savedSettings.environment.image].map;
  // }
  // earcanvas.canvas.background = envs[settings.environment.image].map;
  // TODO: may need to call update reflections
  envSettings
    .add({ image: null }, "image", Object.keys(envs))
    .onChange((value) => {
      settings.environment.image = value;
      earcanvas.canvas.background = envs[value].map;
      earcanvas.canvas.updateReflections();
    });
  if (earcanvas.canvas.cubeCamera) {
    earcanvas.canvas.cubeCamera.position.z = settings.environment.z;
    envSettings
      .add(earcanvas.canvas.cubeCamera.position, "z", -4, 4, 0.001)
      .onChange((value) => {
        settings.environment.z = value;
        earcanvas.canvas.updateReflections();
      });
    earcanvas.canvas.cubeCamera.rotation.y = settings.environment.y;
    envSettings
      .add(settings.environment, "y", -Math.PI, Math.PI, 0.001)
      .onChange((value) => {
        earcanvas.canvas.cubeCamera.rotation.y = value;
        earcanvas.canvas.updateReflections();
      });
  }
  // bloomPass.radius = earcanvas.bloomPass.radius;
  bloomFolder.add({ on: false }, "on").onChange((val) => {
    earcanvas.canvas.composer[val ? "addPass" : "removePass"](
      earcanvas.canvas.bloomPass
    );
    earcanvas.canvas.render(true);
  });
  bloomFolder
    .add(earcanvas.canvas.bloomPass, "threshold", 0, 2, 0.001)
    .onChange(() => {
      earcanvas.canvas.render(true);
    });
  bloomFolder
    .add(earcanvas.canvas.bloomPass, "strength", 0, 3, 0.001)
    .onChange(() => {
      earcanvas.canvas.render(true);
    });
  bloomFolder
    .add(earcanvas.canvas.bloomPass, "radius", 0, 5, 0.001)
    .onChange(() => {
      earcanvas.canvas.render(true);
    });

  saoFolder
    .add(earcanvas.canvas.saoPass.params, "output", {
      Beauty: SAOPass.OUTPUT.Beauty,
      "Beauty+SAO": SAOPass.OUTPUT.Default,
      SAO: SAOPass.OUTPUT.SAO,
      Depth: SAOPass.OUTPUT.Depth,
      Normal: SAOPass.OUTPUT.Normal,
    })
    .onChange((value) => {
      earcanvas.canvas.saoPass.params.output = parseInt(value, 10);
      earcanvas.canvas.render(true);
    });

  saoFolder
    .add(earcanvas.canvas.saoPass.params, "saoBias", -1, 1)
    .onChange(() => {
      earcanvas.canvas.render(true);
    });
  saoFolder
    .add(earcanvas.canvas.saoPass.params, "saoIntensity", 0, 5)
    .onChange(() => {
      earcanvas.canvas.render(true);
    });
  saoFolder
    .add(earcanvas.canvas.saoPass.params, "saoScale", 0, 10)
    .onChange(() => {
      earcanvas.canvas.render(true);
    });
  saoFolder
    .add(earcanvas.canvas.saoPass.params, "saoKernelRadius", 1, 100)
    .onChange(() => {
      earcanvas.canvas.render(true);
    });
  saoFolder
    .add(earcanvas.canvas.saoPass.params, "saoMinResolution", 0, 1)
    .onChange(() => {
      earcanvas.canvas.render(true);
    });
  // saoFolder.add(earcanvas.canvas.saoPass.params, 'saoBlur').onChange(() => { earcanvas.canvas.render(true); });
  // saoFolder.add(earcanvas.canvas.saoPass.params, 'saoBlurRadius', 0, 200).onChange(() => { earcanvas.canvas.render(true); });
  // saoFolder.add(earcanvas.canvas.saoPass.params, 'saoBlurStdDev', 0.5, 150).onChange(() => { earcanvas.canvas.render(true); });
  // saoFolder.add(earcanvas.canvas.saoPass.params, 'saoBlurDepthCutoff', 0.0, 0.1).onChange(() => { earcanvas.canvas.render(true); });

  // TODO would be better to only do this if necessary
  // earcanvas.canvas.updateReflections();

  gui.updateDisplay();
};

const init = () => {
  container = document.querySelector("#tryon-container");
  itemsContainer = document.querySelector("#items-container");
  const dropZone = document.querySelector("#drop_zone");
  earringButtons = document.querySelector("#earring-buttons");
  const resetButton = document.querySelector("#ear-view > .reset");
  earringSelector = document.querySelector("#earringModel");
  earringType = document.querySelector("#earringType");
  Array.from(document.querySelectorAll(".getimage")).forEach((button) => {
    button.addEventListener("click", ({ target }) => {
      earcanvas
        .getImage({ side: target.getAttribute("data-side") })
        .then((res) => {
          if (!res.error) {
            res.image.className = "screenshot";
            document.body.appendChild(res.image);
          }
        });
    });
  });

  const resetCameraButton = document.querySelector("#reset-camera");
  resetCameraButton.addEventListener("click", () => {
    earcanvas.resetZoom();
  });

  resetButton.addEventListener("click", () => {
    while (earrings.length) {
      itemsContainer.querySelector(`[data-id=${earrings.pop()}]`).remove();
      // console.log(earrings.pop());
    }

    earcanvas.reset();
  });

  dropZone.addEventListener("click", () => {
    console.log("trigger upload dialog");
  });

  getModels();

  window.dropHandler = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.items[0].getAsFile();

    const url = `${origin}/mt-earcanvas/upload`;
    const formData = new FormData();
    formData.append("model", file, file.name);

    dropZone.classList.add("uploading");
    dropZone.innerText = "uploading...";
    updated = file.name;

    fetch(url, { method: "POST", body: formData })
      .then((res) => res.json())
      .then((res) => {
        console.log(res);
        dropZone.innerText = "checking model...";

        const fileType = file.name.substring(
          file.name.lastIndexOf(".") + 1,
          file.name.length
        );
        const loader = fileType === "glb" ? GLTFLoader : FBXLoader;
        new loader().load(
          `${origin}/mt-earcanvas/model/${file.name}`,
          (res) => {
            const scene = fileType === "glb" ? res.scene : res;
            console.log("testing", scene);

            // TODO: Other things to check for:
            // collider has no transforms, pos and rot should be 0, scale should be 1
            // item contains at least one item with the name "metal"
            // item doesn't contain any meshes with both metal and diamond in the name

            let collider = null;
            scene.traverse((obj) => {
              if (obj.isMesh && obj.name.toLowerCase().indexOf("collider") >= 0)
                collider = obj;
            });

            if (!collider) {
              fetch(`${origin}/mt-earcanvas/deleteModel/${file.name}`)
                .then((res) => res.json())
                .then(({ success }) => {
                  alert('no mesh named "collider" in file');
                  if (success) {
                    getModels();
                    dropZone.classList.remove("uploading");
                    dropZone.innerText = "Drop an earring here";
                  }
                });
            } else {
              getModels();
              dropZone.classList.remove("uploading");
              dropZone.innerText = "Drop an earring here";
            }
          }
        );
      });
  };

  window.dragOverHandler = (e) => {
    e.preventDefault();
  };

  earcanvas = new EarCanvas(container, {
    resize: true,
    debug: false,
    controls: true,
    quality: "high",
  });
  pmremGenerator = new PMREMGenerator(earcanvas.canvas.renderer);
  pmremGenerator.compileEquirectangularShader();

  errorMessage = document.createElement("div");
  errorMessage.className = "errormessage hidden";
  container.appendChild(errorMessage);

  rotateKnob = document.createElement("input-knob");
  rotateKnob.className = "hidden";
  rotateKnob.addEventListener("knob-move-change", () => {
    const rotated = earcanvas.rotateItem(current, rotateKnob.value * -360);
    // console.log(rotated);
  });
  const rotateGrab = document.createElement("div");
  rotateGrab.className = "mark";
  rotateKnob.appendChild(rotateGrab);
  container.appendChild(rotateKnob);

  earcanvas.element.addEventListener("ready", () => {
    container.classList.remove("loading");

    reflectionDebug = new Mesh(
      new SphereGeometry(0.025, 64, 32),
      new MeshStandardMaterial({
        metalness: 1,
        roughness: 0,
        envMap: earcanvas.canvas.background,
        envMapIntensity: 2,
      })
    );
    reflectionDebug.position.set(0.2, 0.3, 0);
    earcanvas.canvas.scene.add(reflectionDebug);

    setupControls();
  });

  earcanvas.element.addEventListener("activeItemChanged", (e) => {
    current = e.detail.itemID;
    rotateKnob.classList[e.detail.itemID ? "remove" : "add"]("hidden");
    if (e.detail.itemID) {
      const { x, y } = earcanvas.state.items[e.detail.itemID].position2D;
      rotateKnob.style.left = x;
      rotateKnob.style.top = y;
      rotateKnob.value = earcanvas.state.items[e.detail.itemID].rotation / -360;
      earringControls.classList.remove("hidden");
    } else {
      earringControls.classList.add("hidden");
    }
  });

  earcanvas.element.addEventListener("itemDragged", (e) => {
    rotateKnob.classList.add("hidden");
  });

  earcanvas.element.addEventListener("itemMoved", (e) => {
    console.log(e.detail);
    const { x, y } = earcanvas.state.items[e.detail.itemID].position2D;
    rotateKnob.style.left = x;
    rotateKnob.style.top = y;
    rotateKnob.classList.remove("hidden");
  });

  window.earcanvas = earcanvas;

  const earColorButtons = Array.from(
    document.querySelector("#ear-colors").children
  );
  earColorButtons.forEach((button) => {
    button.addEventListener("click", ({ target }) => {
      earcanvas.changeEarColor(parseInt(target.getAttribute("data-color"), 10));
    });
  });

  document.querySelector("#view-left").addEventListener("click", () => {
    reflectionDebug.visible = true;
    reflectionDebug.material.envMap = earcanvas.canvas.background;
    earcanvas.changeView("left");
  });
  document.querySelector("#view-right").addEventListener("click", () => {
    reflectionDebug.visible = true;
    reflectionDebug.position.z = 0.05;
    earcanvas.changeView("right");
    reflectionDebug.material.envMap = earcanvas.canvas.backgroundRight;
  });

  earringControls = document.querySelector("#item-metals");
  Array.from(earringControls.children).forEach((button) => {
    if (button.getAttribute("data-type")) {
      button.addEventListener("click", ({ target }) => {
        // if (current) {
        earcanvas.changeItemMetal(current, target.getAttribute("data-type"));
        // }
      });
    } else {
      button.addEventListener("click", () => {
        earcanvas.deleteItem(current);
      });
    }
  });

  Array.from(document.querySelector("#zones").children).forEach((button) => {
    if (button.getAttribute("data-zone")) {
      button.addEventListener("click", ({ target }) => {
        const id = `earring_${earrings.length}`;
        // const model = models[Math.floor(Math.random() * models.length)];
        // const randomButton = Array.from(earringButtons.children)[Math.floor(Math.random() * earringButtons.children.length)];
        // const model = randomButton.getAttribute('data-file');
        // const type = randomButton.querySelector('.type').innerText;
        // const model = 'http://localhost:8003/mt-earcanvas/model/XETST845D.glb';
        const type = earringType.value;
        const model = earringSelector.value;
        const zone = target.getAttribute("data-zone");

        // randomButton.querySelector('.model').classList.add('updated');
        // setTimeout(() => { randomButton.querySelector('.model').classList.remove('updated'); }, 2000);
        earcanvas
          .addItem(id, { id, model, type, zone, zones: [zone] })
          .then((res) => {
            if (res.error) showError(res.error);

            if (!res.error) {
              earrings.push(res.id);
              const itemButton = createItemButton(res.id);
              itemsContainer.appendChild(itemButton);
            }
          });
      });
    }
  });
};

function LLUI() {
  LLSettings.add(LapisLazuli, "roughness", 0, 1, 0.1).onChange((value) => {
    LapisLazuli.roughness = value;
    earcanvas.canvas.customShaders["LL"].roughness = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  LLSettings.add(LapisLazuli, "metalness", 0, 1, 0.1).onChange((value) => {
    LapisLazuli.metalness = value;
    earcanvas.canvas.customShaders["LL"].metalness = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  LLSettings.add(LapisLazuli, "clearcoatRoughness", 0, 1, 0.1).onChange(
    (value) => {
      LapisLazuli.clearcoatRoughness = value;
      earcanvas.canvas.customShaders["LL"].clearcoatRoughness = value;
      if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
    }
  );
  LLSettings.add(LapisLazuli, "clearcoat", 0, 10, 0.1).onChange((value) => {
    LapisLazuli.clearcoat = value;
    earcanvas.canvas.customShaders["LL"].clearcoat = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  LLSettings.add(LapisLazuli, "envMapIntensity", 0, 2, 0.01).onChange(
    (value) => {
      LapisLazuli.envMapIntensity = value;
      earcanvas.canvas.customShaders["LL"].envMapIntensity = value;
      if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
    }
  );
  LLSettings.add(LapisLazuli, "diffuseScale", 0, 500, 2).onChange((value) => {
    const shader = earcanvas.canvas.customShaders["LL"].userData["shader"];
    shader.uniforms["diffuseScale"].value = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  LLSettings.add(LapisLazuli, "noiseScale", 0, 500, 2).onChange((value) => {
    const shader = earcanvas.canvas.customShaders["LL"].userData["shader"];
    shader.uniforms["noiseScale"].value = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  const blueGrad = LLSettings.addFolder("blueGradient");

  addVector3(blueGrad, LapisLazuli, "LL", "startBlueGradient", 0, 1, 0.01);

  addVector3(blueGrad, LapisLazuli, "LL", "midBlueGradient", 0, 1, 0.01);

  addVector3(blueGrad, LapisLazuli, "LL", "endBlueGradient", 0, 1, 0.01);

  const goldGrad = LLSettings.addFolder("GoldGradient");

  addVector3(goldGrad, LapisLazuli, "LL", "startGoldGradient", 0, 1, 0.01);
  addVector3(goldGrad, LapisLazuli, "LL", "endGoldGradient", 0, 1, 0.01);

  addVector3(LLSettings, LapisLazuli, "LL", "chaos");
}
function PEUI() {
  PESettings.add(pearl, "roughness", 0, 1, 0.01).onChange((value) => {
    pearl.roughness = value;
    earcanvas.canvas.customShaders["PE"].roughness = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  PESettings.add(pearl, "metalness", 0, 1, 0.01).onChange((value) => {
    pearl.metalness = value;
    earcanvas.canvas.customShaders["PE"].metalness = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  PESettings.add(pearl, "clearcoatRoughness", 0, 10, 0.01).onChange((value) => {
    pearl.clearcoatRoughness = value;
    earcanvas.canvas.customShaders["PE"].clearcoatRoughness = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  PESettings.add(pearl, "clearcoat", 0, 10, 0.01).onChange((value) => {
    pearl.clearcoat = value;
    earcanvas.canvas.customShaders["PE"].clearcoat = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  PESettings.add(pearl, "envMapIntensity", 0, 1, 0.01).onChange((value) => {
    pearl.envMapIntensity = value;
    earcanvas.canvas.customShaders["PE"].envMapIntensity = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  const blueNoisgradient = PESettings.addFolder("blue Noise");
  blueNoisgradient
    .add(pearl, "blueNoiseCoef", 0, 200, 0.01)
    .onChange((value) => {
      const shader = earcanvas.canvas.customShaders["PE"].userData["shader"];
      shader.uniforms["blueNoiseCoef"].value = value;
      if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
    });
  const goldNoisgradient = PESettings.addFolder("gold noise");
  goldNoisgradient
    .add(pearl, "goldNoiseCoef", 0, 200, 0.01)
    .onChange((value) => {
      const shader = earcanvas.canvas.customShaders["PE"].userData["shader"];
      shader.uniforms["goldNoiseCoef"].value = value;
      if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
    });
  const colorFlecksgradient = PESettings.addFolder("color Flecks");
  colorFlecksgradient
    .add(pearl, "colorFlecksCoef", 0, 200, 0.01)
    .onChange((value) => {
      const shader = earcanvas.canvas.customShaders["PE"].userData["shader"];
      shader.uniforms["colorFlecksCoef"].value = value;
      if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
    });

  addVector3(
    blueNoisgradient.addFolder("blue gradient start"),
    pearl,
    "PE",
    "blueNoiseStart",
    0,
    1,
    0.01
  );
  addVector3(
    blueNoisgradient.addFolder("blue gradient Mid"),
    pearl,
    "PE",
    "blueNoiseMid",
    0,
    1,
    0.01
  );
  addVector3(
    blueNoisgradient.addFolder("blue gradient end"),
    pearl,
    "PE",
    "blueNoiseEnd",
    0,
    1,
    0.01
  );

  addVector3(
    goldNoisgradient.addFolder("gold gradient start"),
    pearl,
    "PE",
    "goldNoiseStart",
    0,
    1,
    0.01
  );
  addVector3(
    goldNoisgradient.addFolder("gold gradient Mid"),
    pearl,
    "PE",
    "goldNoiseMid",
    0,
    1,
    0.01
  );
  addVector3(
    goldNoisgradient.addFolder("gold gradient end"),
    pearl,
    "PE",
    "goldNoiseEnd",
    0,
    1,
    0.01
  );

  addVector3(
    colorFlecksgradient.addFolder("color Flecks gradient start"),
    pearl,
    "PE",
    "colorFlecksStart",
    0,
    1,
    0.01
  );
  addVector3(
    colorFlecksgradient.addFolder("color Flecks gradient Mid"),
    pearl,
    "PE",
    "colorFlecksMid",
    0,
    1,
    0.01
  );
  addVector3(
    colorFlecksgradient.addFolder("color Flecks gradient end"),
    pearl,
    "PE",
    "colorFlecksEnd",
    0,
    1,
    0.01
  );
}

function TEUI() {
  TESettings.add(tigerEye, "roughness", 0, 1, 0.01).onChange((value) => {
    tigerEye.roughness = value;
    earcanvas.canvas.customShaders["TE"].roughness = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  TESettings.add(tigerEye, "metalness", 0, 1, 0.01).onChange((value) => {
    tigerEye.metalness = value;
    earcanvas.canvas.customShaders["TE"].metalness = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  TESettings.add(tigerEye, "envMapIntensity", 0, 2, 0.01).onChange((value) => {
    tigerEye.envMapIntensity = value;
    earcanvas.canvas.customShaders["TE"].envMapIntensity = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  TESettings.add(tigerEye, "clearcoatRoughness", 0, 10, 0.01).onChange(
    (value) => {
      tigerEye.clearcoatRoughness = value;
      earcanvas.canvas.customShaders["TE"].clearcoatRoughness = value;
      if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
    }
  );
  TESettings.add(tigerEye, "clearcoat", 0, 10, 0.01).onChange((value) => {
    tigerEye.clearcoat = value;
    earcanvas.canvas.customShaders["TE"].clearcoat = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  addVector3(
    TESettings.addFolder("noise1Coefs"),
    tigerEye,
    "TE",
    "noise1coefs",
    0,
    200,
    0.1
  );
  const nois1gradient = TESettings.addFolder("noise1 Gradient");
  addVector3(
    nois1gradient.addFolder("noise1 start"),
    tigerEye,
    "TE",
    "noise1startgradient",
    0,
    1,
    0.01
  );
  addVector3(
    nois1gradient.addFolder("noise1 end"),
    tigerEye,
    "TE",
    "noise1endgradient",
    0,
    1,
    0.01
  );

  addVector3(
    TESettings.addFolder("noise2Coefs"),
    tigerEye,
    "TE",
    "noise2coefs",
    0,
    200,
    0.1
  );
  const nois2gradient = TESettings.addFolder("noise2 Gradient");
  addVector3(
    nois2gradient.addFolder("noise2 start"),
    tigerEye,
    "TE",
    "noise2startgradient",
    0,
    1,
    0.01
  );
  addVector3(
    nois2gradient.addFolder("noise2 end"),
    tigerEye,
    "TE",
    "noise2endgradient",
    0,
    1,
    0.01
  );

  addVector3(
    TESettings.addFolder("noise3Coefs"),
    tigerEye,
    "TE",
    "noise3coefs",
    0,
    200,
    0.1
  );
  const nois3gradient = TESettings.addFolder("noise3 Gradient");
  addVector3(
    nois3gradient.addFolder("noise3 start"),
    tigerEye,
    "TE",
    "noise3startgradient",
    0,
    1,
    0.01
  );
  addVector3(
    nois3gradient.addFolder("noise3 end"),
    tigerEye,
    "TE",
    "noise3endgradient",
    0,
    1,
    0.01
  );

  addVector3(
    TESettings.addFolder("noise4Coefs"),
    tigerEye,
    "TE",
    "noise4coefs",
    0,
    200,
    0.1
  );
  const nois4gradient = TESettings.addFolder("noise4 Gradient");
  addVector3(
    nois4gradient.addFolder("noise4 start"),
    tigerEye,
    "TE",
    "noise4startgradient",
    0,
    1,
    0.01
  );
  addVector3(
    nois4gradient.addFolder("noise4 end"),
    tigerEye,
    "TE",
    "noise4endgradient",
    0,
    1,
    0.01
  );
}

function wopalUI() {
  const shaderKey = "Wopal";
  WopalSettings.add(Wopal, "roughness", 0, 1, 0.01).onChange((value) => {
    Wopal.roughness = value;
    earcanvas.canvas.customShaders[shaderKey].roughness = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  WopalSettings.add(Wopal, "metalness", 0, 1, 0.01).onChange((value) => {
    Wopal.metalness = value;
    earcanvas.canvas.customShaders[shaderKey].metalness = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  WopalSettings.add(Wopal, "tintIntensity", 0, 1, 0.01).onChange((value) => {
    const shader = earcanvas.canvas.customShaders[shaderKey].userData["shader"];
    shader.uniforms["tintIntensity"].value = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  addVector3(
    WopalSettings.addFolder("tint Color"),
    Wopal,
    shaderKey,
    "tintColor",
    0,
    1,
    0.01
  );

  WopalSettings.add(Wopal, "noise1coef", 0, 50, 0.1).onChange((value) => {
    const shader = earcanvas.canvas.customShaders[shaderKey].userData["shader"];
    shader.uniforms["noise1coef"].value = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  const nois1gradient = WopalSettings.addFolder("noise1 Gradient");
  addVector3(
    nois1gradient.addFolder("noise1 start"),
    Wopal,
    shaderKey,
    "noise1startgradient",
    0,
    1,
    0.01
  );
  addVector3(
    nois1gradient.addFolder("noise1 end"),
    Wopal,
    shaderKey,
    "noise1endgradient",
    0,
    1,
    0.01
  );

  WopalSettings.add(Wopal, "noise2coef", 0, 50, 0.1).onChange((value) => {
    const shader = earcanvas.canvas.customShaders[shaderKey].userData["shader"];
    shader.uniforms["noise2coef"].value = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  const nois2gradient = WopalSettings.addFolder("noise2 Gradient");
  addVector3(
    nois2gradient.addFolder("noise2 start"),
    Wopal,
    shaderKey,
    "noise2startgradient",
    0,
    1,
    0.01
  );
  addVector3(
    nois2gradient.addFolder("noise2 end"),
    Wopal,
    shaderKey,
    "noise2endgradient",
    0,
    1,
    0.01
  );

  addVector3(
    WopalSettings.addFolder("noise3Coefs"),
    Wopal,
    shaderKey,
    "noise3coefs",
    0,
    50,
    0.1
  );
  const nois3gradient = WopalSettings.addFolder("noise3 Gradient");
  addVector3(
    nois3gradient.addFolder("noise3 start"),
    Wopal,
    shaderKey,
    "noise3startgradient",
    0,
    1,
    0.01
  );
  addVector3(
    nois3gradient.addFolder("noise3 end"),
    Wopal,
    shaderKey,
    "noise3endgradient",
    0,
    1,
    0.01
  );
}

function addVector3(setting, obj, key, vecName, min = 0, max = 300, step = 1) {
  setting.add(obj[vecName], "x", min, max, step).onChange((value) => {
    const shader = earcanvas.canvas.customShaders[key].userData["shader"];
    const uniformValue = shader.uniforms[vecName].value;
    debugger;
    /* shader.uniforms[vecName].value = new Vector3(value, 
                                         uniformValue.y, uniformValue.z ); */
    uniformValue.x = value;
    obj[vecName].x = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  setting.add(obj[vecName], "y", min, max, step).onChange((value) => {
    const shader = earcanvas.canvas.customShaders[key].userData["shader"];
    const uniformValue = shader.uniforms[vecName].value;
    debugger;
    uniformValue.y = value;
    obj[vecName].y = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  setting.add(obj[vecName], "z", min, max, step).onChange((value) => {
    const shader = earcanvas.canvas.customShaders[key].userData["shader"];
    const uniformValue = shader.uniforms[vecName].value;
    debugger;
    uniformValue.z = value;
    obj[vecName].z = value;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
}

const addColor = (setting, color, shaderName, key, isLinear = false) => {
  setting.add(color, "r", 0, 1, 0.01).onChange((value) => {
    let uniformValue;
    if (earcanvas.canvas.customShaders[shaderName][key])
      uniformValue = earcanvas.canvas.customShaders[shaderName][key];
    else if (earcanvas.canvas.customShaders[shaderName].uniforms[key])
      uniformValue =
        earcanvas.canvas.customShaders[shaderName].uniforms[key].value;
    else return;

    const color = new Color(`rgb(${Math.floor(value * 255)},  
                                 ${Math.floor(uniformValue.g * 255)}, 
                                 ${Math.floor(uniformValue.b * 255)})`);
    if (isLinear) color.convertSRGBToLinear();
    console.log(uniformValue);
    if (earcanvas.canvas.customShaders[shaderName][key])
      earcanvas.canvas.customShaders[shaderName][key].copy(color);
    else if (earcanvas.canvas.customShaders[shaderName].uniforms[key])
      earcanvas.canvas.customShaders[shaderName].uniforms[key].value = color;

    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  setting.add(color, "g", 0, 1, 0.01).onChange((value) => {
    let uniformValue;
    if (earcanvas.canvas.customShaders[shaderName][key])
      uniformValue = earcanvas.canvas.customShaders[shaderName][key];
    else if (earcanvas.canvas.customShaders[shaderName].uniforms[key])
      uniformValue =
        earcanvas.canvas.customShaders[shaderName].uniforms[key].value;
    else return;

    const color = new Color(`rgb(${Math.floor(uniformValue.r * 255)}, 
    ${Math.floor(value * 255)}, 
    ${Math.floor(uniformValue.b * 255)})`);
    if (isLinear) color.convertSRGBToLinear();
    if (earcanvas.canvas.customShaders[shaderName][key])
      earcanvas.canvas.customShaders[shaderName][key].copy(color);
    else if (earcanvas.canvas.customShaders[shaderName].uniforms[key])
      earcanvas.canvas.customShaders[shaderName].uniforms[key].value = color;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  setting.add(color, "b", 0, 1, 0.01).onChange((value) => {
    let uniformValue;
    if (earcanvas.canvas.customShaders[shaderName][key])
      uniformValue = earcanvas.canvas.customShaders[shaderName][key];
    else if (earcanvas.canvas.customShaders[shaderName].uniforms[key])
      uniformValue =
        earcanvas.canvas.customShaders[shaderName].uniforms[key].value;
    else return;
    const color = new Color(`rgb(${Math.floor(uniformValue.r * 255)}, 
    ${Math.floor(uniformValue.g * 255)}, 
    ${Math.floor(value * 255)})`);
    if (isLinear) color.convertSRGBToLinear();
    if (earcanvas.canvas.customShaders[shaderName][key])
      earcanvas.canvas.customShaders[shaderName][key].copy(color);
    else if (earcanvas.canvas.customShaders[shaderName].uniforms[key])
      earcanvas.canvas.customShaders[shaderName].uniforms[key].value = color;
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
};
const addColorFloat = (setting, color, shaderName, key, isLinear = false) => {
  setting.add(color, "r", 0, 1, 0.01).onChange((value) => {
    const shader =
      earcanvas.canvas.customShaders[shaderName].userData["shader"];

    let uniformValue;
    if (earcanvas.canvas.customShaders[shaderName][key])
      uniformValue = earcanvas.canvas.customShaders[shaderName][key];
    else if (shader.uniforms[key]) uniformValue = shader.uniforms[key].value;
    else return;
    if (uniformValue.x) uniformValue.x = value;
    else uniformValue.r = value;
    //if(isLinear)  uniformValue.convertSRGBToLinear();
    console.log(uniformValue);
    /* const color = new Vector3(value, uniformValue.y, uniformValue.z);
    //if (isLinear) color.convertSRGBToLinear();
    if (earcanvas.canvas.customShaders[shaderName][key])
    earcanvas.canvas.customShaders[shaderName][key] = color;
    else if (shader.uniforms[key])
    shader.uniforms[key].value = color; */

    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  setting.add(color, "g", 0, 1, 0.01).onChange((value) => {
    const shader =
      earcanvas.canvas.customShaders[shaderName].userData["shader"];
    let uniformValue;
    if (earcanvas.canvas.customShaders[shaderName][key])
      uniformValue = earcanvas.canvas.customShaders[shaderName][key];
    else if (shader.uniforms[key]) uniformValue = shader.uniforms[key].value;
    else return;
    if (uniformValue.y) uniformValue.y = value;
    else {
      uniformValue.g = value;

      //if(isLinear)  uniformValue.convertSRGBToLinear();
    }

    console.log(uniformValue);
    /* const color = new Vector3(uniformValue.x, value, uniformValue.z );
    //if (isLinear) color.convertSRGBToLinear();
    if (earcanvas.canvas.customShaders[shaderName][key])
    earcanvas.canvas.customShaders[shaderName][key] = color;
    else if (shader.uniforms[key])
    shader.uniforms[key].value = color; */
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
  setting.add(color, "b", 0, 1, 0.01).onChange((value) => {
    const shader =
      earcanvas.canvas.customShaders[shaderName].userData["shader"];
    let uniformValue;
    if (earcanvas.canvas.customShaders[shaderName][key]) {
      uniformValue = earcanvas.canvas.customShaders[shaderName][key];
      if (uniformValue.z) uniformValue.z = value;
      else uniformValue.b = value;
    } else if (shader.uniforms[key]) {
      uniformValue = shader.uniforms[key].value;
      if (uniformValue.z) uniformValue.z = value;
      else uniformValue.b = value;
    } else return;
    //const color = new Vector3(uniformValue.x, uniformValue.y, value);
    if (uniformValue.z) uniformValue.z = value;
    else uniformValue.b = value;
    //if(isLinear)  uniformValue.convertSRGBToLinear();
    //if (isLinear) color.convertSRGBToLinear();
    /* if (earcanvas.canvas.customShaders[shaderName][key])
    earcanvas.canvas.customShaders[shaderName][key] = color;
    else if (shader.uniforms[key])
    shader.uniforms[key].value = color; */
    if (!earcanvas.state.rendering) earcanvas.canvas.render(true);
  });
};
window.addEventListener("load", init);
